(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function initPdp(root) {
    if (!root || root.dataset.ggPdpInit) return;
    root.dataset.ggPdpInit = 'true';

    var configEl = root.querySelector('[data-gg-pdp-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : null;
    var variantIdInput = root.querySelector('[data-gg-pdp-variant-id]');
    var priceEls = root.querySelectorAll('[data-gg-pdp-price]');
    var priceCompareEls = root.querySelectorAll('[data-gg-pdp-price-compare]');
    var priceSaveEls = root.querySelectorAll('[data-gg-pdp-price-save]');
    var ctaButtons = root.querySelectorAll('[data-gg-pdp-atc]');
    var form = root.querySelector('.gg-pdp-form');
    var selected = {};

    // Card upsell con prodotto collegato (checkbox + select): il totale sul
    // CTA principale deve contarne il prezzo quando e' spuntata.
    var bupAtcCard = root.querySelector('.gg-pdp-bup--atc');
    var bupAtcCheck = bupAtcCard && bupAtcCard.querySelector('[data-gg-bup-check]');
    var bupAtcSel = bupAtcCard && bupAtcCard.querySelector('[data-gg-bup-variant]');

    function getBupAtcPriceCents() {
      if (!bupAtcCheck || !bupAtcCheck.checked) return 0;
      var opt =
        bupAtcSel && bupAtcSel.tagName === 'SELECT'
          ? bupAtcSel.options[bupAtcSel.selectedIndex]
          : bupAtcSel;
      var cents = opt && opt.dataset ? parseInt(opt.dataset.priceCents, 10) : NaN;
      return isNaN(cents) ? 0 : cents;
    }

    if (config) {
      config.options.forEach(function (name, i) {
        var key = 'option' + (i + 1);
        var first = root.querySelector('[data-gg-pdp-option="' + (i + 1) + '"] .is-selected');
        if (first) selected[key] = first.dataset.value;
      });
    }

    function findVariant() {
      if (!config) return null;
      return config.variants.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v[k] === selected[k];
        });
      });
    }

    function updateVariant() {
      if (!config) return;
      var variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      // Se l'upsell bundle è spuntato, mostra il prezzo dell'upsell
      // invece di quello della variante, così il prezzo resta coerente
      // con lo stato della checkbox anche al cambio variante.
      var price =
        bupCheck && bupCheck.checked && config.upsellPrice
          ? config.upsellPrice
          : variant.price;
      priceEls.forEach(function (el) {
        el.textContent = formatMoney(price);
      });

      // Prezzo di confronto + risparmio (doc "Bundle" 18/08, punto 2.2): il
      // prezzo grande si muove appena si sceglie il set, non solo al
      // carrello. Il confronto e il risparmio seguono sempre la variante
      // vera anche se l'upsell bundle e' spuntato (il bundle non c'entra
      // col compare_at_price della collanina).
      var hasCompare = variant.compareAtPrice && variant.compareAtPrice > variant.price;
      priceCompareEls.forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = formatMoney(variant.compareAtPrice);
      });
      priceSaveEls.forEach(function (el) {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = 'Risparmi ' + formatMoney(variant.compareAtPrice - variant.price);
      });

      // Il CTA dice il totale (prodotto + collanina se spuntata): deve
      // aggiornarsi subito al tocco della checkbox o del menu, altrimenti
      // spuntare la checkbox non ha un effetto visibile (doc Luca 18/08).
      var ctaTotal = variant.price + getBupAtcPriceCents();
      ctaButtons.forEach(function (btn) {
        btn.disabled = !variant.available;
        var label = btn.dataset.labelDefault || 'Aggiungi al carrello';
        btn.textContent = variant.available
          ? label + ' · ' + formatMoney(ctaTotal)
          : 'Esaurito';
      });
    }

    // Al cambio variante la galleria salta alla foto della variante (Marco
    // 10/08): se la variante ha una featured_media presente tra le thumbnail
    // si riusa il click sulla thumb — stesso meccanismo dell'utente, quindi
    // stato attivo, video e anteprima incisione restano coerenti. Senza
    // media associata (o senza thumbnail, prodotti con un solo media) non
    // succede niente.
    function syncGalleryToVariant() {
      var variant = findVariant();
      if (!variant || !variant.featured_media) return;
      var thumb = root.querySelector(
        '[data-gg-pdp-gallery-thumb][data-media-id="' + variant.featured_media + '"]'
      );
      if (thumb && !thumb.classList.contains('is-active')) thumb.click();
    }

    // ".gg-pdp-bundle-row" e' la riga verticale dei prodotti bundle (Sole,
    // Luna, Sole+Luna...), stesso gruppo/comportamento di ".gg-pdp-var".
    var OPTION_BTN_SELECTOR = '.gg-pdp-var, .gg-pdp-bundle-row';
    root.querySelectorAll('[data-gg-pdp-option]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest(OPTION_BTN_SELECTOR);
        if (!btn || btn.disabled) return;

        group.querySelectorAll(OPTION_BTN_SELECTOR).forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var pos = parseInt(group.dataset.ggPdpOption, 10);
        selected['option' + pos] = btn.dataset.value;
        updateVariant();
        syncGalleryToVariant();
      });
    });

    var galleryMain = root.querySelector('[data-gg-pdp-gallery-main]');
    root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');

        if (!galleryMain) return;
        var mediaType = thumb.dataset.mediaType;
        var src = thumb.dataset.src;
        var videoSrc = thumb.dataset.videoSrc;
        var alt = thumb.dataset.alt || '';

        if (mediaType === 'video' && videoSrc) {
          galleryMain.innerHTML =
            '<video src="' +
            videoSrc +
            '" controls playsinline poster="' +
            (src || '') +
            '" style="width:100%;height:100%;object-fit:cover;border-radius:20px;"></video>';
        } else if (src) {
          galleryMain.innerHTML =
            '<img src="' + src + '" alt="' + alt + '" loading="lazy">';
        }
      });
    });

    root.querySelectorAll('[data-gg-pdp-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.gg-pdp-acc__item').classList.toggle('is-open');
      });
    });

    root.querySelectorAll('[data-gg-pdp-faq]').forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });

    var igToggle = root.querySelector('[data-gg-pdp-ig-toggle]');
    var igShots = root.querySelector('[data-gg-pdp-ig-shots]');
    if (igToggle && igShots) {
      igToggle.addEventListener('click', function () {
        igShots.classList.toggle('is-open');
      });
    }

    var bupCheck = root.querySelector('[data-gg-pdp-bup]');
    if (bupCheck && config && config.upsellPrice) {
      bupCheck.addEventListener('change', function () {
        var variant = findVariant();
        if (!variant) return;
        var price = bupCheck.checked ? config.upsellPrice : variant.price;
        priceEls.forEach(function (el) {
          el.textContent = formatMoney(price);
        });
      });
    }

    if (bupAtcCard) {
      initBupAtc(bupAtcCard, updateVariant);
      if (bupAtcCheck) bupAtcCheck.addEventListener('change', updateVariant);
    }

    // Marco 27/08: submit del form SEMPRE via AJAX (bug segnalato su
    // "qualsiasi prodotto" — senza checkbox upsell spuntata il form faceva
    // submit nativo, apriva /cart intera invece del drawer). Unico listener
    // per tutti i casi: se la card upsell esiste ed e' spuntata usa la
    // logica bundle di prima, altrimenti aggiunta generica via FormData.
    initFormSubmit(form, bupAtcCard, bupAtcCheck, bupAtcSel);

    // Anteprima live del testo personalizzato sul ciondolo: mentre il cliente
    // scrive, la galleria mostra la foto "pulita" con il testo sovrapposto.
    var engraveInput = root.querySelector('.gg-pdp-engrave');
    var engraveStage = root.querySelector('[data-gg-engrave-stage]');
    if (engraveInput && engraveStage) {
      var engraveGallery = engraveStage.parentElement;
      var engraveText = engraveStage.querySelector('[data-gg-engrave-text]');
      var sizeFrac = parseFloat(engraveStage.dataset.size || '5.5') / 100;
      var maxWFrac = parseFloat(engraveStage.dataset.maxw || '24') / 100;
      var maxHFrac = parseFloat(engraveStage.dataset.maxh || '14') / 100;

      // Il testo va a capo dentro la larghezza massima (come dipinto sulla
      // targhetta) e il font scala finché il blocco non sta anche in altezza.
      var fitEngrave = function () {
        var w = engraveStage.clientWidth;
        if (!w) return;
        var maxW = w * maxWFrac;
        var maxH = w * maxHFrac;
        var fs = w * sizeFrac;
        engraveText.style.width = maxW + 'px';
        for (var i = 0; i < 12; i++) {
          engraveText.style.fontSize = fs + 'px';
          if (engraveText.scrollHeight <= maxH && engraveText.scrollWidth <= maxW + 1) break;
          fs *= 0.85;
        }
      };

      // Vincoli call 18/07 (collanina innamorati): a capo dopo 8 caratteri,
      // massimo 2 righe — se il testo non ci sta, l'input rifiuta i caratteri.
      var ENGRAVE_LINE_MAX = 8;
      var ENGRAVE_LINES_MAX = 2;
      var engraveWrap = function (str) {
        var words = String(str || '').trim().split(/\s+/).filter(Boolean);
        var lines = [];
        var cur = '';
        var push = function () { if (cur) { lines.push(cur); cur = ''; } };
        words.forEach(function (word) {
          var w = word;
          while (w.length > ENGRAVE_LINE_MAX) {
            push();
            lines.push(w.slice(0, ENGRAVE_LINE_MAX));
            w = w.slice(ENGRAVE_LINE_MAX);
          }
          if (!w) return;
          if (!cur) cur = w;
          else if (cur.length + 1 + w.length <= ENGRAVE_LINE_MAX) cur += ' ' + w;
          else { push(); cur = w; }
        });
        push();
        return lines;
      };
      var engraveLastValid = '';

      engraveInput.addEventListener('input', function () {
        var value = engraveInput.value.trim();
        var lines = engraveWrap(value);
        if (lines.length > ENGRAVE_LINES_MAX) {
          engraveInput.value = engraveLastValid;
          return;
        }
        engraveLastValid = engraveInput.value;
        if (!value) {
          engraveStage.hidden = true;
          return;
        }
        if (!engraveStage.isConnected) engraveGallery.appendChild(engraveStage);
        engraveText.textContent = lines.join('\n');
        engraveStage.hidden = false;
        fitEngrave();
      });

      // il click su una thumbnail riporta alla galleria normale
      root.querySelectorAll('[data-gg-pdp-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          engraveStage.hidden = true;
        });
      });

      window.addEventListener('resize', fitEngrave);
    }

    updateVariant();
  }

  // ------------------------------------------------------------------
  // Barra fissa "Aggiungi al carrello" (snippet gg-pdp-cartbar)
  //
  // Vale per tutti i template prodotto: scheda normale e i tre configuratori.
  // La barra riceve dal markup quale CTA osservare e da dove leggere il
  // totale, quindi non duplica né la validazione né il calcolo del prezzo:
  //  - il click sulla barra clicca la CTA vera della pagina, che valida e
  //    aggiunge al carrello come farebbe l'utente premendola;
  //  - il totale è uno specchio del nodo che la pagina aggiorna già.
  // ------------------------------------------------------------------
  function initCartbar(bar) {
    if (bar.dataset.ggCartbarInit) return;
    bar.dataset.ggCartbarInit = 'true';

    var cta = document.querySelector(bar.dataset.cartbarWatch || '');
    if (!cta) {
      // nessuna CTA in pagina: una barra che non sa cosa fare è peggio di niente
      bar.remove();
      return;
    }

    var btn = bar.querySelector('[data-gg-cartbar-cta]');
    if (btn) {
      btn.addEventListener('click', function () {
        cta.click();
      });
    }

    var totalEl = bar.querySelector('[data-gg-cartbar-total]');
    var totalSrc = bar.dataset.cartbarTotalFrom
      ? document.querySelector(bar.dataset.cartbarTotalFrom)
      : null;

    if (totalEl && totalSrc) {
      var syncTotal = function () {
        var text = totalSrc.textContent.trim();
        if (text) totalEl.textContent = text;
      };
      syncTotal();
      new MutationObserver(syncTotal).observe(totalSrc, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // La barra si vede quando la CTA è fuori schermo — in qualunque direzione,
    // così su un riepilogo lungo il totale è sempre a portata. Se la CTA non è
    // renderizzata (step non attivo, configuratore ancora chiuso) resta
    // nascosta: negli step intermedi il totale sta già su "Passo successivo".
    // La soglia di scroll evita che su mobile la barra copra il fondo della
    // pagina già all'atterraggio, quando la CTA non è ancora stata vista.
    var SCROLL_MIN = 120;
    var refresh = function () {
      var rect = cta.getBoundingClientRect();
      var rendered = rect.width > 0 || rect.height > 0;
      var onScreen = rect.bottom > 0 && rect.top < (window.innerHeight || 0);
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > SCROLL_MIN;
      var show = rendered && !onScreen && scrolled;
      bar.classList.toggle('is-visible', show);
      // serve a nascondere le altre barre fisse della pagina (vedi gg-pdp.css)
      document.body.classList.toggle('gg-cartbar-on', show);
    };

    var frame = null;
    var schedule = function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        refresh();
      });
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(schedule, { threshold: 0 }).observe(cta);
    }
    // il cambio di step non muove la CTA nel viewport, la fa apparire da
    // display:none: l'IntersectionObserver non lo segnala, il resize sì
    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(cta);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    refresh();
  }

  /* Card upsell con prodotto collegato: la checkbox (Luca, doc "Checkbox
     sull'upsell prezzo dinamico" 18/08) sostituisce il vecchio bottone
     "Aggiungi" — niente piu' due CTA identiche vicine. Qui solo select
     variante/foto e validazione del testo personalizzato: il submit del
     form (bundle se spuntata, generico altrimenti) e' unificato in
     initFormSubmit qui sotto. onPriceChange ricalcola il totale sul CTA
     principale. */
  function initBupAtc(card, onPriceChange) {
    var check = card.querySelector('[data-gg-bup-check]');
    var sel = card.querySelector('[data-gg-bup-variant]');
    if (!check || !sel) return;
    var price = card.querySelector('[data-gg-bup-price]');

    if (sel.tagName === 'SELECT') {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        if (price && opt.dataset.price) price.textContent = opt.dataset.price;
        // la foto della card segue la variante scelta (Marco 09/08)
        if (opt.dataset.image) {
          var foto = card.querySelector('.gg-pdp-bup-media img');
          if (foto) {
            foto.src = opt.dataset.image;
            foto.removeAttribute('srcset');
          }
        }
        if (onPriceChange) onPriceChange();
      });
    }

    var testo = card.querySelector('[data-gg-bup-text]');
    if (testo) {
      testo.addEventListener('input', function () {
        testo.classList.remove('is-error');
      });
    }
  }

  /* Submit del form principale, sempre via AJAX (Marco 27/08). Prima, senza
     la checkbox upsell spuntata (o senza card upsell del tutto — la
     maggioranza dei prodotti), il form faceva il suo submit nativo: bug
     segnalato su "qualsiasi prodotto", apriva /cart intera invece del
     drawer. Un solo listener per entrambi i casi:
     - checkbox spuntata: aggiunge il SET (prodotto + collanina, con le
       eventuali properties come il testo sul ciondolo) in un solo fetch;
     - altrimenti: aggiunta generica via FormData(form), cosi' viaggiano da
       soli anche i campi che le app iniettano nel form (Easify, personal.)
       senza doverli elencare a mano.
     In entrambi i casi apre il drawer via cart:refresh {open:true} (vedi
     cart-drawer.js). */
  function initFormSubmit(form, card, check, sel) {
    if (!form) return;
    var testo = card ? card.querySelector('[data-gg-bup-text]') : null;

    form.addEventListener('submit', function (evt) {
      var submitBtn = form.querySelector('[data-gg-pdp-atc]');
      var labelBase = submitBtn ? submitBtn.textContent : null;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      function finish(response) {
        return response
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            if (submitBtn) submitBtn.textContent = 'Aggiunto ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .catch(function () {
            if (submitBtn) submitBtn.textContent = 'Riprova';
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove('is-loading');
              if (labelBase) setTimeout(function () { submitBtn.textContent = labelBase; }, 2500);
            }
          });
      }

      if (check && sel && check.checked && !check.disabled) {
        evt.preventDefault();

        // testo personalizzato obbligatorio quando il campo e' in card
        if (testo && !testo.value.trim()) {
          testo.classList.add('is-error');
          testo.focus();
          return;
        }

        var item = { id: Number(sel.value), quantity: 1 };
        if (testo) {
          item.properties = {};
          item.properties[testo.getAttribute('placeholder') || 'Testo'] = testo.value.trim();
        }

        // bundle: la collanina viaggia insieme al prodotto della pagina, nella
        // sua variante E con le sue properties (es. "Testo sul ciondolo") —
        // senza, la personalizzazione andrebbe persa
        var items = [];
        var madre = form.querySelector('[data-gg-pdp-variant-id]');
        if (madre && madre.value) {
          var mainItem = { id: Number(madre.value), quantity: 1 };
          var props = {};
          var campi = form.querySelectorAll('[name^="properties["]');
          var bloccato = false;
          campi.forEach(function (campo) {
            var nome = campo.name.slice(11, -1);
            var valore = (campo.value || '').trim();
            if (campo.required && !valore) {
              campo.focus();
              campo.classList.add('is-error');
              campo.addEventListener('input', function () { campo.classList.remove('is-error'); }, { once: true });
              bloccato = true;
              return;
            }
            if (valore) props[nome] = valore;
          });
          if (bloccato) return;
          if (Object.keys(props).length) mainItem.properties = props;
          items.push(mainItem);
        }
        items.push(item);

        if (submitBtn) submitBtn.classList.add('is-loading');
        finish(fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }));
        return;
      }

      evt.preventDefault();
      if (submitBtn) submitBtn.classList.add('is-loading');
      finish(fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }));
    });
  }

  function boot() {
    document.querySelectorAll('[data-gg-pdp-root]').forEach(initPdp);
    document.querySelectorAll('[data-gg-cartbar]').forEach(initCartbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
